import React from 'react';
import styled from 'styled-components';

const BrandPreviewDiv = styled.div`
  .brand-preview {
    --preview-page-width: 340px;
    --preview-page-height: calc(var(--preview-page-width) * 1.4142);
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex-wrap: nowrap;
    position: absolute;
    top: calc(100% + 12px);
    right: 0;
    z-index: 20;
    width: max-content;
    max-width: calc(100vw - 80px);
    overflow-x: auto;
    padding-bottom: 6px;

    &__pdf,
    &__email {
      border-radius: 10px;
      border: 1px solid #e8e5ef;
      background-color: #ffffff;
      overflow: hidden;
      box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
    }

    &__pdf {
      width: calc(var(--preview-page-width) + 28px);
      height: calc(var(--preview-page-height) + 70px);
      display: flex;
      flex-direction: column;
      background-color: #f4f6fb;
    }

    &__pdf-scroll {
      padding: 12px 14px 18px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      overflow-y: auto;
      height: 100%;
      align-items: center;
    }

    &__pdf-page {
      width: var(--preview-page-width);
      aspect-ratio: 210 / 297;
      border-radius: 2px;
      background-color: #ffffff;
      border: 1px solid #e8e5ef;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
      flex: 0 0 auto;
    }

    &__pdf-banner {
      padding: 10px 14px 12px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &__pdf-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }

    &__pdf-spacer {
      height: 8px;
    }

    &__pdf-logo {
      width: 62px;
      height: 22px;
      object-fit: contain;
    }

    &__pdf-company {
      font-size: 8.5px;
      font-weight: 600;
      color: #022033;
      text-align: right;
    }

    &__pdf-title {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-top: 4px;
    }

    &__pdf-label {
      font-size: 8px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    &__pdf-heading {
      font-size: 12px;
      font-weight: 600;
      color: #022033;
    }

    &__pdf-body {
      padding: 12px 14px 12px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1;
      justify-content: flex-end;
    }

    &__pdf-line {
      height: 5px;
      border-radius: 4px;
      background-color: #e8e5ef;
    }

    &__pdf-line--wide {
      width: 100%;
    }

    &__pdf-line--short {
      width: 70%;
    }

    &__pdf-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr)) 1.2fr;
      gap: 8px 10px;
    }

    &__pdf-field {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    &__pdf-footer {
      height: 18px;
      border-top: 1px solid #e8e5ef;
      background-color: #f4f6fb;
    }

    &__toc-header {
      padding: 12px 16px;
      border-bottom: 1px solid #e8e5ef;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }

    &__toc-body {
      display: flex;
      gap: 12px;
      padding: 12px 16px 14px;
      flex: 1;
    }

    &__toc-indicator {
      width: 6px;
      background-color: #f4f6fb;
      border-radius: 6px;
      overflow: hidden;
    }

    &__toc-indicator-fill {
      width: 100%;
      height: 24px;
      border-radius: 6px;
    }

    &__toc-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__toc-title {
      font-size: 12px;
      font-weight: 600;
      color: #022033;
    }

    &__toc-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;
    }

    &__toc-item {
      display: grid;
      grid-template-columns: 28px 1fr 22px;
      align-items: center;
      gap: 6px;
      font-size: 9px;
      color: #022033;
    }

    &__toc-item-line {
      border-bottom: 1px dashed #e8e5ef;
      height: 1px;
      width: 100%;
      margin-top: 6px;
    }

    &__email {
      width: calc(var(--preview-page-width) + 28px);
      height: calc(var(--preview-page-height) + 70px);
      display: flex;
      flex-direction: column;
      background-color: #f0f4fb;
      border-radius: 10px;
      border: 1px solid #e8e5ef;
      overflow: hidden;
    }

    &__email-header {
      padding: 20px 12px 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    &__email-logo {
      width: 36px;
      height: 36px;
      object-fit: contain;
    }

    &__email-brand {
      font-size: 13px;
      font-weight: 700;
      color: #022033;
    }

    &__email-body {
      padding: 0 16px 20px;
      display: flex;
      flex-direction: column;
      flex: 1;
      align-items: center;
    }

    &__email-card {
      width: 100%;
      max-width: 220px;
      background-color: #ffffff;
      border: 1px solid #e8e5ef;
      border-radius: 2px;
      box-shadow:
        0 2px 0 rgba(0, 0, 150, 0.025),
        2px 4px 0 rgba(0, 0, 150, 0.015);
      padding: 18px 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    &__email-text {
      font-size: 11px;
      color: #022033;
      line-height: 1.5;
    }

    &__email-heading {
      font-size: 11px;
      font-weight: 700;
      color: #022033;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    &__email-link {
      font-size: 11px;
      color: #3869d4;
      text-decoration: underline;
      font-weight: 500;
    }

    &__email-alert {
      font-size: 11px;
      color: #e53e3e;
      font-weight: 600;
    }

    &__email-signoff {
      font-size: 11px;
      color: #022033;
    }
  }
`;

interface BrandPreviewProps {
  primaryColor: string;
  secondaryColor: string;
  logoSrc: string;
  logoShadow: boolean;
  orgName: string;
}

export const BrandPreview: React.FC<BrandPreviewProps> = ({
  primaryColor,
  secondaryColor,
  logoSrc,
  logoShadow,
  orgName,
}) => {
  return (
    <BrandPreviewDiv>
      <div className="brand-preview">
        <div className="brand-preview__pdf">
          <div className="brand-preview__pdf-scroll">
            <div className="brand-preview__pdf-page">
              <div className="brand-preview__pdf-banner" style={{ backgroundColor: primaryColor }}>
                <div className="brand-preview__pdf-top">
                  <img
                    className={['brand-preview__pdf-logo', logoShadow && 'logo-shadow'].filter(Boolean).join(' ')}
                    src={logoSrc}
                    alt="PDF logo preview"
                  />
                  <span className="brand-preview__pdf-company">{orgName}</span>
                </div>
                <div className="brand-preview__pdf-spacer" />
                <div className="brand-preview__pdf-title">
                  <span className="brand-preview__pdf-label" style={{ color: secondaryColor }}>
                    Risk assessment
                  </span>
                  <span className="brand-preview__pdf-heading">{orgName} assessment</span>
                </div>
              </div>
              <div className="brand-preview__pdf-body">
                <span className="brand-preview__pdf-label" style={{ color: secondaryColor }}>
                  Description
                </span>
                <div className="brand-preview__pdf-line brand-preview__pdf-line--wide" />
                <div className="brand-preview__pdf-line brand-preview__pdf-line--wide" />
                <div className="brand-preview__pdf-grid">
                  {['Report date', 'Start date', 'Edited', 'Updated', 'Exported by'].map((label) => (
                    <div key={label} className="brand-preview__pdf-field">
                      <span className="brand-preview__pdf-label" style={{ color: secondaryColor }}>
                        {label}
                      </span>
                      <div className="brand-preview__pdf-line brand-preview__pdf-line--short" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="brand-preview__pdf-footer" />
            </div>
            <div className="brand-preview__pdf-page">
              <div className="brand-preview__toc-header">
                <img
                  className={['brand-preview__pdf-logo', logoShadow && 'logo-shadow'].filter(Boolean).join(' ')}
                  src={logoSrc}
                  alt="PDF logo preview"
                />
                <span className="brand-preview__pdf-company">Back to top</span>
              </div>
              <div className="brand-preview__toc-body">
                <div className="brand-preview__toc-indicator">
                  <div
                    className="brand-preview__toc-indicator-fill"
                    style={{ backgroundColor: primaryColor }}
                  />
                </div>
                <div className="brand-preview__toc-content">
                  <div className="brand-preview__toc-title">TABLE OF CONTENTS</div>
                  <div className="brand-preview__toc-list">
                    {[
                      { title: 'Executive summary', page: '01' },
                      { title: 'Assessment summary', page: '02' },
                      { title: 'Scenarios', page: '03' },
                      { title: 'Risk management', page: '04' },
                      { title: 'Incidents', page: '05' },
                    ].map((item) => (
                      <div key={item.title} className="brand-preview__toc-item">
                        <span style={{ fontWeight: 600 }}>{item.page}</span>
                        <div>
                          <span>{item.title}</span>
                          <div className="brand-preview__toc-item-line" />
                        </div>
                        <span style={{ textAlign: 'right' }}>{item.page}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="brand-preview__pdf-footer" />
            </div>
          </div>
        </div>
        <div className="brand-preview__email">
          <div className="brand-preview__email-header">
            <img
              className={['brand-preview__email-logo', logoShadow && 'logo-shadow'].filter(Boolean).join(' ')}
              src={logoSrc}
              alt="Email logo preview"
            />
            <span className="brand-preview__email-brand">{orgName}</span>
          </div>
          <div className="brand-preview__email-body">
            <div className="brand-preview__email-card">
              <div className="brand-preview__email-text">Hi {orgName},</div>
              <div className="brand-preview__email-text">
                The following items are due for review in the next week:
              </div>
              <div className="brand-preview__email-heading">DUE TODAY</div>
              <div className="brand-preview__email-text" style={{ fontWeight: 600 }}>
                Controls:
              </div>
              <div>
                <span className="brand-preview__email-link">Control 4</span>
                <span> – </span>
                <span className="brand-preview__email-alert">Today</span>
              </div>
              <div className="brand-preview__email-signoff">Regards,</div>
              <div className="brand-preview__email-signoff">Cydea</div>
            </div>
          </div>
        </div>
      </div>
    </BrandPreviewDiv>
  );
};
